module.exports = __webpack_public_path__ + "static/media/happy-hour-image.b6a22139.png";